import { maxStringMsg } from '@utils/basic'
import { REQUIRED_FIELD } from '@constants'
import * as Yup from 'yup'
import { hasSpecialCharacters } from '@utils/hasSpecialCharacters'

const allowedSpecialCharacters = ['-', '_', '.']

export const taskFormId = 'task_form'
export const taskSchema = Yup.object({
  OT_ACT_ID: Yup.string()
    .typeError(REQUIRED_FIELD)
    .max(12, maxStringMsg(12))
    .test({
      test: function (taskID) {
        if (!taskID) return true

        return !hasSpecialCharacters(taskID, allowedSpecialCharacters)
      },
      message: `Task ID contains invalid special characters. ${
        allowedSpecialCharacters.length > 0
          ? `Allowed characters: A–Z, a–z, 0–9,${allowedSpecialCharacters.join(' , ')} `
          : ''
      }`,
    })
    .required(REQUIRED_FIELD),
  OT_DESC: Yup.string()
    .typeError(REQUIRED_FIELD)
    .max(50, maxStringMsg(50))
    .required(REQUIRED_FIELD),
  OT_RETD_CD: Yup.string().nullable(),
  OT_OAPC_ID: Yup.string().nullable(),
  OT_ODPC_ID: Yup.string().nullable(),
})
export type Task = Yup.InferType<typeof taskSchema>
export type TaskKey = keyof Task

export const initialTask: Task = {
  OT_ACT_ID: '',
  OT_DESC: '',
  OT_RETD_CD: undefined,
  OT_OAPC_ID: undefined,
  OT_ODPC_ID: undefined,
}

// Payloads and responses

export interface FetchTasksResponse {
  count: number
  list: Task[]
}
